/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () =>
  chance.pickone([
    {
      id: 1200,
      subClassification: {
        id: 6142,
      },
    },
    {
      id: 1204,
      subClassification: {
        id: 6087,
      },
    },
    {
      id: 1209,
      subClassification: {
        id: 6035,
      },
    },
    {
      id: 6281,
      subClassification: {
        id: 6290,
      },
    },
    {
      id: 1220,
      subClassification: {
        id: 1546,
      },
    },
  ]);
